import { useEffect, useState, type CSSProperties } from 'react';

const INTRO_SESSION_KEY = 'gsoft_intro_seen';
const INTRO_DURATION_MS = 1800;
const REDUCED_MOTION_DURATION_MS = 250;
const INTRO_CHARACTERS = ['G', '-', 'S', 'O', 'F', 'T', 'W', 'A', 'R', 'E'];

function shouldShowIntro() {
  try {
    return window.sessionStorage.getItem(INTRO_SESSION_KEY) !== '1';
  } catch {
    return true;
  }
}

export default function IntroSplash() {
  const [visible, setVisible] = useState(shouldShowIntro);

  useEffect(() => {
    if (!visible) return;

    try {
      window.sessionStorage.setItem(INTRO_SESSION_KEY, '1');
    } catch {
      // The intro still works when browser storage is unavailable.
    }

    const previousOverflow = document.body.style.overflow;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.body.style.overflow = 'hidden';

    const timerId = window.setTimeout(
      () => setVisible(false),
      reducedMotion ? REDUCED_MOTION_DURATION_MS : INTRO_DURATION_MS
    );

    return () => {
      window.clearTimeout(timerId);
      document.body.style.overflow = previousOverflow;
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="gsoft-intro" aria-hidden="true">
      <div className="gsoft-intro__content">
        <div className="gsoft-intro__word" aria-label="G-Software">
          {INTRO_CHARACTERS.map((character, index) => (
            <span
              key={`${character}-${index}`}
              className={`gsoft-intro__letter ${index === 0 ? 'gsoft-intro__letter--accent' : ''} ${character === '-' ? 'gsoft-intro__letter--separator' : ''}`}
              style={{ '--intro-index': index } as CSSProperties}
            >
              {character}
            </span>
          ))}
        </div>
        <span className="gsoft-intro__line" />
      </div>
    </div>
  );
}
